<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html, body, #app {
  height: 100%;
  margin: 0;
  font-family: "Segoe UI", "PingFang SC", "Microsoft YaHei", sans-serif;
  color: #303133;
  -webkit-font-smoothing: antialiased;
}
* {
  box-sizing: border-box;
  scrollbar-width: auto;
  scrollbar-color: #909399 #ebeef5;
}
::-webkit-scrollbar {
  width: 28px;
  height: 28px;
}
::-webkit-scrollbar-track {
  background: #ebeef5;
  border-radius: 14px;
}
::-webkit-scrollbar-thumb {
  background: #909399;
  border-radius: 14px;
  border: 4px solid #ebeef5;
  min-height: 80px;
  min-width: 80px;
}
::-webkit-scrollbar-thumb:hover {
  background: #606266;
}
::-webkit-scrollbar-corner {
  background: #ebeef5;
}
/* Element 表格横向滚动条 */
.el-table__body-wrapper::-webkit-scrollbar {
  height: 28px;
}
.el-table__body-wrapper::-webkit-scrollbar-thumb {
  min-width: 96px;
}
.el-card {
  border-radius: 10px;
  border: none;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.06);
}
.el-table {
  border-radius: 8px;
  overflow: hidden;
}
.el-button--primary {
  background: linear-gradient(90deg, #409eff, #3a8ee6);
  border: none;
}

/* 日期范围：「至」垂直居中 */
body .el-date-editor--daterange.el-input__inner {
  display: inline-flex;
  align-items: center;
}
body .el-date-editor--daterange .el-range-separator {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1 !important;
  height: auto;
  padding: 0 8px;
  width: auto !important;
  min-width: 28px;
  flex-shrink: 0;
  box-sizing: content-box;
  float: none;
}
body .el-date-editor--daterange .el-range-input {
  flex: 1;
  min-width: 0;
  text-align: center;
}

/* 列表表头、表体默认居中（含弹窗内表格） */
body .el-table th > .cell {
  text-align: center !important;
  justify-content: center;
}
body .el-table td > .cell {
  text-align: center;
  justify-content: center;
}

.page-toolbar {
  margin-bottom: 4px;
}

/* 弹窗：不超屏、表单标签完整显示不换行 */
.el-dialog {
  max-width: calc(100vw - 32px);
}
.el-dialog__body .el-form--label-left .el-form-item,
.el-card .el-form--label-left .el-form-item,
.main-content .el-form--label-left .el-form-item {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
}
.el-dialog__body .el-form--label-left .el-form-item__label,
.el-card .el-form--label-left .el-form-item__label,
.main-content .el-form--label-left .el-form-item__label {
  white-space: nowrap;
  word-break: keep-all;
  flex: 0 0 auto;
  min-width: 132px;
  width: auto !important;
  float: none;
  line-height: 32px;
  padding-right: 12px;
}
.el-dialog__body .el-form--label-left .el-form-item__content,
.el-card .el-form--label-left .el-form-item__content,
.main-content .el-form--label-left .el-form-item__content {
  flex: 1 1 260px;
  min-width: 0;
  margin-left: 0 !important;
  line-height: 32px;
}
.el-dialog__body .el-form--label-top .el-form-item__label,
.el-card .el-form--label-top .el-form-item__label,
.main-content .el-form--label-top .el-form-item__label {
  white-space: nowrap;
  word-break: keep-all;
}
</style>
